import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { O5StackUpsertDialog } from '../../../../../../../features/o5/stack/o5-stack-upsert-dialog';
import { type O5StackCustomTableHeaderProps, O5StacksTable } from '../../../../../../../features/o5/stack/o5-stacks-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/stack/_stack/')({
  head: () => getPageHead('Stacks'),
  component: O5StacksList,
});

function TableHeader({ filter, search }: O5StackCustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <O5StackUpsertDialog trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Upsert Stack" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      </HorizontalStack>

      {search}
    </VerticalStack>
  );
}

function O5StacksList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <O5StacksTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
